import React, { useEffect, useState } from "react";
import electricity from '../images/pictures/pexels-tomfisk-6135327.jpg';
import solar from '../images/pictures/pexels-tomfisk-9893727.jpg';
import campus from '../images/pictures/pexels-pixabay-356036.jpg';
import logoPequeño from '../images/logo-fundemas.png';
import Brand from '../images/image.png';
import { getOrDeleteRequest } from "../utils/utils";
import { useLocation } from "react-router-dom";
import Form2FA from "../components/Auth/Form2FA";
// import { getOrDeleteRequest } from "../utils/utils";

const MainSectionLayout = ({ children, id, view2FA, setView2FA, factor }) => {
    const [loading, setLoading] = useState(true);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const [fileName, setFileName] = useState(null);
    const location = useLocation().pathname;

    const getData = async () => {
        let response = await getOrDeleteRequest(
            `ribbon/filter`,
            'GET',
            null,
            false
        );
        if (response.type === 'success') {
            if (response.data.length > 0) {
                const images = response.data
                    .filter((item) => item.place === 'Sistema Inicio')
                    .map((item) => item.image)

                setFileName(images.length > 0 ? images[0] : null);
            } else {
                setFileName(null);
            }
            return;
        }
    };

    const loadData = async () => {
        setLoading(true);
        await getData();
        setImagesLoaded(true);
        setLoading(false);
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="flex flex-row w-full items-center md:items-stretch h-screen overflow-y-auto dark:bg-[#292929] overscroll-none">
            {!view2FA &&
                <div className="w-full md:w-1/2 flex flex-col justify-end md:justify-between items-center mb-4 overflow-y-auto">
                    <div></div>
                    <div className="w-3/4 flex flex-col justify-center items-center mb-4">
                        <div className="w-full relative">
                            {location === '/' && <>
                                {/* <div className="mb-2 flex justify-start">
                                <span className="bg-transparent dark:bg-white rounded-lg p-4">
                                    <img src={logoPequeño} alt="" className="w-48" />
                                </span>
                            </div> */}
                                <h1 className="text-2xl font-bold text-center text-stone-700 dark:text-white mb-4">
                                    <span className="text-turquesa">Plataforma para el registro y monitoreo de indicadores ambientales</span>
                                </h1>
                            </>}
                            {children}
                        </div>
                    </div>
                    <div className="flex flex-row w-full px-12 bg-transparent min-h-[100px] overflow-hidden">
                        {/* {loading || !imagesLoaded ? (
                        <div className="flex flex-row flex-wrap w-full justify-center items-center gap-2">
                            {[...Array(1)].map((_, index) => (
                                <div key={index} className="w-auto px-1 py-3 bg-gray-300 animate-pulse rounded-lg">
                                    <img
                                        src={Brand}
                                        className="w-full object-contain invisible"
                                        alt=""
                                    />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="flex flex-row flex-wrap w-full justify-center items-center gap-2">
                            <div className="w-auto px-1 py-3 bg-white rounded-lg">
                                <img
                                    src={Brand}
                                    className="w-full object-contain"
                                    alt=""
                                />
                            </div>
                        </div>
                    )} */}
                        {fileName && <div className="flex flex-row flex-wrap w-full justify-center items-center gap-2">
                            <div className="w-auto px-1 py-3 bg-white rounded-lg">
                                <img
                                    src={`${process.env.REACT_APP_PHOTO_URI}photo/ribbon/image/${fileName}`}
                                    className="w-full object-contain"
                                    alt=""
                                />
                            </div>
                        </div>}
                    </div>
                </div>
            }
            {/**Habilitar proximamente en el proceso 2FA */}
            {/* {view2FA && <Form2FA fileName={fileName} setView2FA={setView2FA} factor={factor} />} */}

            <div className="w-1/2 h-full bg-cover bg-center bg-no-repeat border-4 rounded-lg border-white dark:border-stone-800 hidden md:block"
                style={{ backgroundImage: `url(${id === "InitialForm" ? solar : id === "IndicatorForm" ? campus : electricity})` }}>
                <div className="flex flex-col justify-end w-full h-full">
                    <h1 className="text-white text-4xl font-medium p-8">
                        El poder de los <br /> datos al servicio del <br /> medio ambiente.
                    </h1>
                </div>
            </div>
        </div>
    );
};

export default MainSectionLayout;
